import NavigationZone from "./NavigationZone";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faXmark } from '@fortawesome/free-solid-svg-icons';
import emailjs from "@emailjs/browser";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";



const GetInTouch = (e) => {

    const [formData, setFormData] = useState('')
    const [formData2, setFormData2] = useState('')
    const [formData3, setFormData3] = useState('')
    const [formData4, setFormData4] = useState('')
    const [formData5, setFormData5] = useState('')
    const [lastPart, setLastPart] = useState(false)
   const [isAnimating2, setIsAnimating] = useState(false)

    const [submitData, setSubmitData] = useState(true)
    const [loading, setLoading] = useState(false)

  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Delay ensures it's applied after navigation

  }, [pathname]);
      const handleChange1 = (e) => {
        const {value} = e.target
        setFormData(value)
      }

      const handleChange2 = (e) => {
        const {value} = e.target
        setFormData2(value)
      }
      const handleChange3 = (e) => {
        const {value} = e.target
        setFormData3(value)
      }

      const handleChange4 = (e) => {
        const {value} = e.target
        setFormData4(value)
      }

      const handleChange5 = (e) => {
        const {value} = e.target
        setFormData5(value)
      }


const submitBtn = () => {
    if ( formData === '' || formData2 === '' || formData3 === '' || formData4 === '' || formData5 === '') {
        
      
    }else{
    setLoading(true)
    setSubmitData(false)
    
    setTimeout(() => {
        setLastPart(true)
        setIsAnimating(false)
    },5000)
    }

    
}
  const cancelTop = () => {
    setIsAnimating(true)
    setFormData('')
    setFormData2('')
    setFormData3('')
    setFormData4('')
    setFormData5('')
    setLoading(false)
    setSubmitData(true)
  }

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [message, setMessage] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userLocation, setUserLocation] = useState("");



  const [isSent, setIsSent] = useState(false); 
  const [isSending, setIsSending] = useState(false); // To track sending state
const [bringIn, setBringIn] = useState(false)
const [bringIn2, setBringIn2] = useState(false)

        // e.preventDefault();






    return ( 
        <div className="getIn-Touch">
            <NavigationZone />
            <div className="bringBoth">
                <div className="bring1">
                <img src="inCode.jpg"/>        
                </div>
                <div className="bring2">
                    <h1>Get in touch</h1>
                    <form onSubmit={(e) => {
                e.preventDefault(); // ✅ Prevents auto-submit

                setIsSending(true); // Show loading state while sending

                // EmailJS parameters
                const templateParams = {
                    user_name: userName,
                    user_email: userEmail,
                    message: message,
                    user_number: userNumber,
                    user_location: userLocation
                };

                emailjs.send(
                    "service_2ryfvgv",   // ✅ Replace with your EmailJS Service ID
                    "template_ausia4m",  // ✅ Replace with your EmailJS Template ID
                    templateParams,
                    "1vK7XgkGgOH1yT1ot"    // ✅ Replace with your EmailJS Public Key
                ).then(response => {
                    console.log("Email sent successfully!", response);
                    setIsSent(true);  // ✅ Show success message
                    setIsSending(false); // ✅ Stop loading state
                    setUserName("");
                    setUserEmail("");
                    setMessage("");
                    setUserLocation("");
                    setUserNumber("");
                    setLastPart(true);  
                    if(setLastPart) {
                      setBringIn(true)
                      
                      setTimeout(() => {
                        setBringIn(false)
                      }, 5000)
                    }

                    // setTimeout(() => setIsAnimating(true), 2000); 
                }).catch(error => {
                    console.error("Error sending email:", error);
                    // alert("Failed to send message. Please try again.");
                    setIsSending(false); // ✅ Stop loading state
                    setBringIn2(true)
                    setTimeout(() => {
                      setBringIn2(false)
                    }, 5000)
                });
            }}>
        {/* <label htmlFor="name">Name:</label> */}
        <input
          type="text"
          id="name"
          name="name"
          placeholder="NAME*"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          required
        />
        <br /><br />
        {/* <label htmlFor="email">Email:</label> */}
        <input
          type="email"
          id="email"
          name="email"
          placeholder="E-MAIL*"
        //   value={formData.email}
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value)}
        required
        />
    <br /> <br />


<input
          type="number"
          id="email"
          name="email"
          placeholder="NUMBER*"
        //   value={formData.email}
        value={userNumber}
        onChange={(e) => setUserNumber(e.target.value)}
          required
        />
        <br /><br />

        <input
          type="text"
          id="email"
          name="email"
          placeholder="LOCATION*"
        //   value={formData.email}
        value={userLocation}
        onChange={(e) => setUserLocation(e.target.value)}
          required
        />
        <br /><br />


        <input
          type="text"
          id="message"
          name="email"
          placeholder="MESSAGE*"
        //   value={formData.email}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
        />
        <br /><br />




        {/* <button type="submit">Submit</button> */}
        <div className="getIN5">
            {/* {submitData &&
                  <div className="getIN">
                  <p onClick={submitBtn}  type="submit" disabled={isSending}>
                  {isSending ? "Sending..." : "Confirm"}Submit</p>
              </div>
            }
  {loading && 
          <div className="emoji1">
          <FontAwesomeIcon icon={faSpinner} spinPulse />
          </div>
  } */}
 
                  <button type="submit" disabled={isSending} className="getIN">
                    {isSending ? <FontAwesomeIcon icon={faSpinner} spinPulse /> : "Submit"} {/* Shows "Sending..." while processing */}
                </button>
                

        </div>
      </form>
                            </div>












            </div>
            {lastPart &&
    <div className={`blackPart ${isAnimating2 ? "downDown" : ""}`}>
        <FontAwesomeIcon icon={faXmark} className="xFactor" onClick={cancelTop}/>
   <div className="styleBlack">
      <div className="thankYou">
         <p>Thank you for getting in touch!</p>
         <p>We will get back to you as soon as possible</p>
      </div>
   </div>
    </div>}



    {/* <!-- From Uiverse.io by akshat-patel28 -->  */}
    {bringIn && 
    
<div class="card">
  <svg class="wave" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0,256L11.4,240C22.9,224,46,192,69,192C91.4,192,114,224,137,234.7C160,245,183,235,206,213.3C228.6,192,251,160,274,149.3C297.1,139,320,149,343,181.3C365.7,213,389,267,411,282.7C434.3,299,457,277,480,250.7C502.9,224,526,192,549,181.3C571.4,171,594,181,617,208C640,235,663,277,686,256C708.6,235,731,149,754,122.7C777.1,96,800,128,823,165.3C845.7,203,869,245,891,224C914.3,203,937,117,960,112C982.9,107,1006,181,1029,197.3C1051.4,213,1074,171,1097,144C1120,117,1143,107,1166,133.3C1188.6,160,1211,224,1234,218.7C1257.1,213,1280,139,1303,133.3C1325.7,128,1349,192,1371,192C1394.3,192,1417,128,1429,96L1440,64L1440,320L1428.6,320C1417.1,320,1394,320,1371,320C1348.6,320,1326,320,1303,320C1280,320,1257,320,1234,320C1211.4,320,1189,320,1166,320C1142.9,320,1120,320,1097,320C1074.3,320,1051,320,1029,320C1005.7,320,983,320,960,320C937.1,320,914,320,891,320C868.6,320,846,320,823,320C800,320,777,320,754,320C731.4,320,709,320,686,320C662.9,320,640,320,617,320C594.3,320,571,320,549,320C525.7,320,503,320,480,320C457.1,320,434,320,411,320C388.6,320,366,320,343,320C320,320,297,320,274,320C251.4,320,229,320,206,320C182.9,320,160,320,137,320C114.3,320,91,320,69,320C45.7,320,23,320,11,320L0,320Z"
      fill-opacity="1"
    ></path>
  </svg>

  <div class="icon-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      stroke-width="0"
      fill="currentColor"
      stroke="currentColor"
      class="icon"
    >
      <path
        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
      ></path>
    </svg>
  </div>
  <div class="message-text-container">
    <p class="message-text">Success message</p>
    <p class="sub-text">Everything seems great</p>
  </div>
  {/* <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    stroke-width="0"
    fill="none"
    stroke="currentColor"
    class="cross-icon"
  >
    <path
      fill="currentColor"
      d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
      clip-rule="evenodd"
      fill-rule="evenodd"
    ></path>
  </svg> */}
</div>
}


{bringIn2 && 
    
    <div class="card">
      <svg class="wave2" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0,256L11.4,240C22.9,224,46,192,69,192C91.4,192,114,224,137,234.7C160,245,183,235,206,213.3C228.6,192,251,160,274,149.3C297.1,139,320,149,343,181.3C365.7,213,389,267,411,282.7C434.3,299,457,277,480,250.7C502.9,224,526,192,549,181.3C571.4,171,594,181,617,208C640,235,663,277,686,256C708.6,235,731,149,754,122.7C777.1,96,800,128,823,165.3C845.7,203,869,245,891,224C914.3,203,937,117,960,112C982.9,107,1006,181,1029,197.3C1051.4,213,1074,171,1097,144C1120,117,1143,107,1166,133.3C1188.6,160,1211,224,1234,218.7C1257.1,213,1280,139,1303,133.3C1325.7,128,1349,192,1371,192C1394.3,192,1417,128,1429,96L1440,64L1440,320L1428.6,320C1417.1,320,1394,320,1371,320C1348.6,320,1326,320,1303,320C1280,320,1257,320,1234,320C1211.4,320,1189,320,1166,320C1142.9,320,1120,320,1097,320C1074.3,320,1051,320,1029,320C1005.7,320,983,320,960,320C937.1,320,914,320,891,320C868.6,320,846,320,823,320C800,320,777,320,754,320C731.4,320,709,320,686,320C662.9,320,640,320,617,320C594.3,320,571,320,549,320C525.7,320,503,320,480,320C457.1,320,434,320,411,320C388.6,320,366,320,343,320C320,320,297,320,274,320C251.4,320,229,320,206,320C182.9,320,160,320,137,320C114.3,320,91,320,69,320C45.7,320,23,320,11,320L0,320Z"
          fill-opacity="1"
        ></path>
      </svg>
    
      <div class="icon-container2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          stroke-width="0"
          fill="currentColor"
          stroke="currentColor"
          class="icon2"
        >
          <path
            d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
          ></path>
        </svg>
      </div>
      <div class="message-text-container">
        <p class="message-text2">Unsuccessful message</p>
        <p class="sub-text">Check connection and retry</p>
      </div>
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        stroke-width="0"
        fill="none"
        stroke="currentColor"
        class="cross-icon"
      >
        <path
          fill="currentColor"
          d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
      </svg> */}
    </div>
    }

        </div>
     );
}
 
export default GetInTouch;